import dayjs, { Dayjs } from "dayjs";

export const formatCurrency = (
  amount: number | undefined,
  currency: string = "USD",
  showDecimals: boolean = false
) => {
  if (!amount) return "";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(amount);
};
// Format currency with abbreviations for large numbers
export const formatCurrencyForStats = (value: number): string => {
  if (value >= 1000000000) {
    return `$${(value / 1000000000).toFixed(1)}B`;
  } else if (value >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  } else if (value >= 1000) {
    return `$${(value / 1000).toFixed(1)}K`;
  } else {
    return `$${value.toFixed(0)}`;
  }
};

export const formatInterval = (interval: string, intervalCount: number) => {
  if (intervalCount === 1) {
    switch (interval) {
      case "day":
        return "/day";
      case "week":
        return "/week";
      case "month":
        return "/month";
      case "year":
        return "/year";
      default:
        return "";
    }
  } else {
    return `/${intervalCount} ${interval}s`;
  }
};

export function getShortMonthName(monthNumber: number): string {
  const date = new Date();
  date.setMonth(monthNumber - 1); // JavaScript months are 0-11
  return date.toLocaleString("en-US", { month: "short" });
}

export const handleNumberInputKeyDown = (evt: React.KeyboardEvent) => {
  if (["+", "-"].includes(evt.key)) {
    evt.preventDefault();
  }
};

export const formatDate = (
  dateString: string | Date | Dayjs | undefined | null
): string => {
  if (!dateString) return "";
  if (dateString instanceof Date) {
    return dateString.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
  if (dayjs.isDayjs(dateString)) {
    return dateString.format("MMMM D, YYYY");
  }
  // Handle string dates (from API)
  if (typeof dateString === "string") {
    const parsedDate = dayjs(dateString);
    if (parsedDate.isValid()) {
      return parsedDate.format("MMMM D, YYYY");
    }
  }
  return "";
};

export function removeCounty(address: string): string {
  return address.replace(
    /(?:,\s*)?County(?:\s*[:\-]\s*|\s+of\s+|\s+)\s*[^,]+/gi,
    ""
  );
}

export const libraries: (
  | "places"
  | "drawing"
  | "geometry"
  | "visualization"
)[] = ["places"];
